import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

const Confirm = props => {
    return (
        <div>
            {props.trigger}
            <Dialog
                open={props.open}
                onClose={props.onCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {props.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.content || 'Are you sure?'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => props.onConfirm?.()}>Yes</Button>
                    <Button autoFocus onClick={() => props.onCancel?.()}>No</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}


export default Confirm;
